"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
const useScrollToTop = () => {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = [pathname];
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp, t0);
};
export default useScrollToTop;
function _temp() {
  window.scrollTo({
    top: 0,
    behavior: "instant"
  });
}